import { type AxiosInstance } from 'axios'

interface Answer {
  id: number
  body: string[]
}

interface Question {
  title: string
  number: string
  qn_body: string[]
  answers: Answer[]
}

interface Subchapter {
  title: string
  questions: Question[]
}

interface Chapter {
  title: string
  number: string
  description: string
  questions: Question[]
  subchapters: Subchapter[]
}

interface EsgReport {
  id: number
  company: string
  reporting_year: number | string
  short_form: string
  framework: string
  template_name: string
  version_year: number | string
  type_of_reporting: string
  other_type: null | string
  base_year: number | string
  region: null | string
  body: Chapter[]
  generated_by: string
  status: string
  created_on: string
  updated_on: string
}

interface ReportDataFilters {
  range: string
  year: number
  location: string
}

export default (axios: AxiosInstance) => ({
  listFrameworks() {
    return axios.get('/v1/reporting/frameworks/')
  },
  getFramework(id: number | string) {
    return axios.get(`/v1/reporting/frameworks/${id}/`)
  },
  listWithStatus(status: string = 'published') {
    return axios.get(`/v1/reporting/frameworks/list/?status=${status}`)
  },
  generateDocument(report: EsgReport, fileType: string = 'pdf') {
    return axios.post(`/v1/reports/esg-report/generate-document/?document_type=${fileType}`, report, { responseType: 'blob' })
  },
  frameworkQuestions(query: string = '') {
    return axios.get(`/v1/reporting/frameworks/questions/amoq/${query}`)
  },
  companyCdpReport(companyId: number, reportDataFilters: ReportDataFilters) {
    const { range, year, location } = reportDataFilters
    return axios.get(`/v1/reporting/frameworks/cdp/${companyId}/${range}/${year}/${location}`)
  },
  listTemplates() {
    return axios.get('/v1/reporting/frameworks/templates/')
  },
  templateById(value: string) {
    return axios.get(`/v1/reporting/frameworks/templates/${value}/`)
  },
})
